import React from 'react'
import { SimpleTabs } from '../Tab/Tab'

const TabbedProductListing = (props) => {
  return (
    <>
      { props.innerElements?.length > 0 &&
        <div className='my-5'>
          <SimpleTabs displayChildren={true} {...props} />
        </div>
      }
    </>

  )
}

export { TabbedProductListing }